import Main from '@/views/administracion/configuracion/catalogos/contratistas/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/contratistas/Default.vue';
import MainContratista from '@/views/administracion/configuracion/catalogos/contratistas/contratista/Main.vue';
import DefaultContratista from '@/views/administracion/configuracion/catalogos/contratistas/contratista/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const contratistas = [
  {
    path: 'contratistas',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoContratistas',
        path: '/',
        meta: {
          title: 'Contratistas',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':id',
        meta: {
          title: 'Contratista',
          auth,
          scopes,
        },
        component: MainContratista,
        children: [
          {
            name: 'contratista',
            path: '/',
            meta: {
              title: 'Contratista',
              auth,
              scopes,
            },
            component: DefaultContratista,
          },
        ],
      },
    ],
  },
];

export default contratistas;
